import { GiftCardPaymentStatus, GiftCardStatus } from 'shared/models'

const paymentStatusText: Record<GiftCardPaymentStatus, string> = {
  Failed: 'Отклонено',
  None: '',
  Paid: 'Оплачен',
  Requested: 'Запрошено'
}

const giftCardStatusText: Record<GiftCardStatus, string> = {
  Created: 'Создан',
  Active: 'Активен',
  Expired: 'Истек',
  Used: 'Погашен',
  Cancelled: 'Отменен'
}

const giftCardStatusColor: Record<GiftCardStatus, string> = {
  Created: '#000',
  Active: '#fff',
  Expired: '#fff',
  Used: '#0000006b',
  Cancelled: '#fff'
}

const giftCardStatusBackground: Record<GiftCardStatus, string> = {
  Created: '#e7e7e7',
  Active: '#11b511',
  Expired: '#e01b1b',
  Used: '#0000000d',
  Cancelled: '#e01b1b'
}

export { paymentStatusText, giftCardStatusText, giftCardStatusColor, giftCardStatusBackground }
